import { Cell, Grid, HFlow, Icon, Text, VFlow } from 'bold-ui'
import { InfoIcon } from 'components/InfoIcon'
import { Color } from 'csstype'
import { css } from 'emotion'
import React from 'react'
import { ListagemGestantePuerperaExameModel } from 'view/acompanhamento/acompanhamento-condicao-saude/model/lista-tematica/model-gestantePuerpera'
import { labelByStatus } from 'view/acompanhamento/acompanhamento-condicao-saude/utils-acompanhamentoCondicaoSaude'

import {
  EXAMES_HEPATITE_B_TOOLTIP_TEXT,
  EXAMES_HEPATITE_C_TOOLTIP_TEXT,
  EXAMES_HIV_TOOLTIP_TEXT,
  EXAMES_SIFILIS_TOOLTIP_TEXT,
} from '../constants-acompanhamentoCondicaoSaudeAccordion'

export interface AcompanhamentoCondicaoSaudeGestantePuerperaExamesSectionProps {
  examesRealizadosPreNatal: ListagemGestantePuerperaExameModel
  iconColor: Color
}

export function AcompanhamentoCondicaoSaudeGestantePuerperaExamesSection({
  examesRealizadosPreNatal,
  iconColor,
}: Readonly<AcompanhamentoCondicaoSaudeGestantePuerperaExamesSectionProps>) {
  return (
    <Grid gap={1} gapVertical={0.5} alignItems='baseline'>
      <Cell size={12}>
        <HFlow hSpacing={0.5} alignItems='center'>
          <Icon width='1rem' icon='fileWithItemsFilled' color={iconColor} />
          <Text fontWeight='bold'>Exames - Avaliação</Text>
        </HFlow>
      </Cell>
      <Cell size={3}>
        <VFlow vSpacing={0.25}>
          <HFlow hSpacing={0.25}>
            <Text fontWeight='bold'>HIV (1º trimestre)</Text>
            <InfoIcon text={EXAMES_HIV_TOOLTIP_TEXT} icon='infoCircleFilled' tooltipStyle={styles.tooltip} />
          </HFlow>
          <Text>{labelByStatus(examesRealizadosPreNatal?.hivPrimeiroTrimestre)}</Text>
        </VFlow>
      </Cell>
      <Cell size={3}>
        <VFlow vSpacing={0.25}>
          <HFlow hSpacing={0.25}>
            <Text fontWeight='bold'>Sífilis (1º trimestre)</Text>
            <InfoIcon text={EXAMES_SIFILIS_TOOLTIP_TEXT} icon='infoCircleFilled' tooltipStyle={styles.tooltip} />
          </HFlow>
          <Text>{labelByStatus(examesRealizadosPreNatal?.sifilisPrimeiroTrimestre)}</Text>
        </VFlow>
      </Cell>
      <Cell size={3}>
        <VFlow vSpacing={0.25}>
          <HFlow hSpacing={0.25}>
            <Text fontWeight='bold'>Hepatite B (1º trimestre)</Text>
            <InfoIcon text={EXAMES_HEPATITE_B_TOOLTIP_TEXT} icon='infoCircleFilled' tooltipStyle={styles.tooltip} />
          </HFlow>
          <Text>{labelByStatus(examesRealizadosPreNatal?.hepatiteBPrimeiroTrimestre)}</Text>
        </VFlow>
      </Cell>
      <Cell size={3}>
        <VFlow vSpacing={0.25}>
          <HFlow hSpacing={0.25}>
            <Text fontWeight='bold'>Hepatite C (1º trimestre)</Text>
            <InfoIcon text={EXAMES_HEPATITE_C_TOOLTIP_TEXT} icon='infoCircleFilled' tooltipStyle={styles.tooltip} />
          </HFlow>
          <Text>{labelByStatus(examesRealizadosPreNatal?.hepatiteCPrimeiroTrimestre)}</Text>
        </VFlow>
      </Cell>
      <Cell size={3}>
        <VFlow vSpacing={0.25}>
          <HFlow hSpacing={0.25}>
            <Text fontWeight='bold'>HIV (3º trimestre)</Text>
            <InfoIcon text={EXAMES_HIV_TOOLTIP_TEXT} icon='infoCircleFilled' tooltipStyle={styles.tooltip} />
          </HFlow>
          <Text>{labelByStatus(examesRealizadosPreNatal?.hivTerceiroTrimestre)}</Text>
        </VFlow>
      </Cell>
      <Cell size={3}>
        <VFlow vSpacing={0.25}>
          <HFlow hSpacing={0.25}>
            <Text fontWeight='bold'>Sífilis (3º trimestre)</Text>
            <InfoIcon text={EXAMES_SIFILIS_TOOLTIP_TEXT} icon='infoCircleFilled' tooltipStyle={styles.tooltip} />
          </HFlow>
          <Text>{labelByStatus(examesRealizadosPreNatal?.sifilisTerceiroTrimestre)}</Text>
        </VFlow>
      </Cell>
    </Grid>
  )
}

const styles = {
  tooltip: css`
    max-width: 31rem;
    white-space: pre-line;
  `,
}
